function removeItem(data_line,qty){
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity="+qty+"&id=" + data_line,
    dataType: "json",
    success: function (e){
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        load_cart();
      }
    },
    error: function (e, t){}
  });
}
$(document).on('click','.ci_plus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  var data_stock = $qty.data('stock');

  console.log('data_stock---',data_stock)
  
  if (!isNaN(currentVal) && currentVal < data_stock) {
    $qty.val(currentVal+1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_plus').data('line');
    removeItem(data_line,input_qty);
  }

  
});
$(document).on('click','.ci_minus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_minus').data('line');
    removeItem(data_line,input_qty);
  }
});
$(document).on('click','.cd_variantbtn',function (e) {
  e.preventDefault();
  $(this).next('.cd__variant_list').slideToggle().closest('.cartitems').siblings().find('.cd__variant_list').slideUp();
  $(this).toggleClass('active').closest('.cartitems').siblings().find('.cd_variantbtn').removeClass('active');
});
$(document).on('click','.us_variantbtn',function (e) {
  e.preventDefault();
  $(this).next('.cd__variant_list').slideToggle().closest('.us_prod_list').siblings().find('.cd__variant_list').slideUp();
  $(this).toggleClass('active').closest('.us_prod_list').siblings().find('.us_variantbtn').removeClass('active');
});
$(document).on('click', '.cd_variant', function (e) {
  e.preventDefault();
  $(this).closest('.cartitems').find('.cd__variant_list').slideUp();
  $(this).closest('.cartitems').find('.cd_variantbtn').removeClass('active');
  var cart_error = $(this).closest('.cartitems').find('.cierror');
  var currentid = $(this).closest('.cartitems').find('.item-remove').data('line');
  var changevar_id = $(this).data('id');
  var item_current_qty = $(this).closest('.cartitems').find('.cart_qty').val();
  
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: changevar_id, quantity: item_current_qty },
    dataType: "json",
    success: function (t) {
      setTimeout(function (e) {
        removeItem(currentid, 0);
        clearError(cart_error); // Clear the error message on success
      }, 500);
    },
    error: function (e, t) {
      cart_error.text(e.responseJSON.description);
      // Remove the setTimeout function to keep the error message visible
    }
  });
});

// Function to clear the error message
function clearError(cart_error) {
  cart_error.text('');
}
$('body').on('click',function(e){   
  var cartvariant = $(".cd_variantbtn,.us_variantbtn,.cd__variant_list");    
  if (!cartvariant.is(e.target) && cartvariant.has(e.target).length === 0){
    $('.cd__variant_list').slideUp();
    $('.cd_variantbtn,.us_variantbtn').removeClass('active');
  }
});
$(document).on('click','.us_variant',function (e){
  e.preventDefault();
  $(this).parents('.cd_variant_cls').find('.us_variantbtn span').text($(this).text());
  $(this).parents('.cd_variant_cls').next('.us_cart_btn').attr('data-id',$(this).attr('data-id'));
  $(this).closest('.us_prod_list').find('.cd__variant_list').slideUp();
  $(this).closest('.us_prod_list').find('.us_variantbtn').removeClass('active');
});
function addCart(id,error_text){
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: id, quantity: 1 },
    dataType: "json",
    success: function (data) {
      if(document.location.href.indexOf('/cart') > -1) {
          window.location.href = "/cart";
      }else{
        load_cart();
      }
    },
    error: function (e, t) {
      error_text.text(e.responseJSON.description);
      setTimeout(function () {
        error_text.text("");
      }, 2000);
    },
  });
}
$(document).on('click','.us_cart_btn',function (e) {
  e.preventDefault();
  var grid_error = $(this).next(".grid-error");
  var changevar_id = $(this).data("id");
  addCart(changevar_id,grid_error);
});
$(document).on('click','.cpvariant-grid',function(e){
  e.preventDefault();
  var changevar_id = $(this).data("id");
  var grid_error = $(this).closest(".us_prod_list").find(".grid-error");
  addCart(changevar_id,grid_error);
});

if(!window.location.href.includes('/pages/wishlist')){
  setTimeout(function() {
    $(document).on('click', '.th_wl_button', function(e){
      setTimeout(function() {
        let wlCount = localStorage.getItem('th_wlc_pro_count');
        console.log('wlCount---',wlCount)
        if(wlCount > 0){
          let headerIcon = $('.header-right .th_wlc_position_relative');
          headerIcon.each(function() {
            $(this).addClass('active');
          });
        }
      }, 3000);
    })
    $(document).on('click', '.th_wl_button_after', function(e){
      setTimeout(function() {
        let wCount = Number(localStorage.getItem('th_wlc_pro_count'));
        console.log('wCount---',wCount)
        if(wCount === 0){
          let headerIcon = $('.header-right .th_wlc_position_relative');
          headerIcon.each(function() {
            $(this).removeClass('active');
          });
        }
      }, 3000);
    })   

    $(document).on('click', '.th_wl_col_btn, .th_prd_wl_btn', function(e) {
      var variantId = $(this).attr('data-variant_id');
    });
  }, 3200);
}

$(document).on('click', '.pd-quick-view',function() {
  // Toggle the 'active' class on the clicked .pd-quick-view container
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
  } else {
    // Remove 'active' class from all .pd-quick-view elements
    $('.pd-quick-view').removeClass('active');
    $(this).addClass('active');
  }
});


$(document).on('click', '.plus-icon', function() {
  const productItem = this.closest('.snippet-product-grid');
  if (productItem) {
    let quickView = productItem.querySelector('.mobile-quick-view');
    if (quickView) {
      quickView._originalParent = productItem; // Store reference to move it back later
      document.body.appendChild(quickView);
      setTimeout(function() {
        quickView.classList.add('active');
        document.body.classList.add('quick-view-open');
      }, 50);
    }
  }
});

$(document).on('click', '.modelclose, .mobile-overlay', function() {
  const quickView = this.closest('.mobile-quick-view');
  if (quickView) {
    quickView.classList.remove('active');
    document.body.classList.remove('quick-view-open');
    // Move back home after closing animation
    setTimeout(function() {
      if (quickView._originalParent) {
        quickView._originalParent.appendChild(quickView);
      }
    }, 400);
  }
});

$(document).on('click', '.mobile-quick-variants .mobvar', function() {
  $(this).closest('.mobile-quick-variants').find('.mobvar').removeClass('focus');
  $(this).addClass('focus');
  var newId = $(this).data('id');
  $(this).closest('.info').find('.add-to-cart .btn').attr('data-id', newId);
});

$(document).on('click', '.add-to-cart .btn', function() {
  var variantId = $(this).attr('data-id');
  if (variantId) {
    addItemNewwMob(variantId);
    $(this).attr('data-id', '');
  }
});


const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      const isDrawerOpen = document.body.classList.contains('open-drawer');
      if (isDrawerOpen) {
        $('.mobile-quick-view.active').each(function() {
          const $qv = $(this);
          $qv.removeClass('active');
          document.body.classList.remove('quick-view-open');
          
          setTimeout(function() {
            if ($qv[0]._originalParent) {
              $qv[0]._originalParent.appendChild($qv[0]);
            }
          }, 400);
        });
      }
    }
  });
});

observer.observe(document.body, { attributes: true });


window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    window.location.reload();
  }
});
